import React from 'react';
import PropTypes from 'prop-types';
import { Box, makeStyles } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import { useHistory } from 'react-router';
import Typography from 'Components/UI/Typography';
import Button from '../Button';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 0),
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  count: {
    marginLeft: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    borderRadius: '50%',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightBold,
    height: 24,
    width: 24,
    lineHeight: '24px',
    fontSize: 12,
  },
  buttons: {
    display: 'flex',
  },
  [theme.breakpoints.down('sm')]: {
    root: {
      flexDirection: 'column',
    },
    buttons: {
      width: '100%',
      justifyContent: 'space-between',
    },
  },
}));

export default function ActionItemsHeader(props) {
  const {
    count, readOnly, loading, TitleProps,
  } = props;
  const classes = useStyles();
  const history = useHistory();
  const searchParams = new URLSearchParams(history.location.search);
  const showHidden = searchParams.get('showHidden');

  const toggleHidden = () => {
    searchParams.set('refresh', 'action-items');
    if (showHidden) {
      searchParams.delete('showHidden');
    } else {
      searchParams.set('showHidden', 'true');
    }
    history.push({
      search: searchParams.toString(),
    });
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.title}>
        <Typography variant={'h4'} color="black" weight={'bold'} {...TitleProps}>
          {'To-Dos'}
        </Typography>
        <Box component="span" className={classes.count}>
          {count}
        </Box>
      </Box>
      <div className={classes.buttons}>
        <Button
          onClick={toggleHidden}
          disabled={loading}
          color="primary"
        >
          {showHidden ? 'Show Active' : 'Show Hidden'}
        </Button>
        {!readOnly && (
          <Button
            disabled={loading}
            onClick={() => openModal(
              readOnly ? modalConsts.simpleActionItemModal : modalConsts.clientActionItemModal,
            )
              }
            color="secondary"
            endIcon={<AddCircleIcon color="secondary" fontSize="default" />}
          >
            {'Add To-Do'}
          </Button>)
        }
      </div>
    </Box>
  );
}

ActionItemsHeader.propTypes = {
  count: PropTypes.number.isRequired,
  readOnly: PropTypes.bool,
  loading: PropTypes.bool,
};

ActionItemsHeader.defaultProps = {
  readOnly: false,
  loading: false,
};
